import { format } from 'date-fns/format';
// remove resumable from OSS upload; use raw upload instead
const actionToUrl = (action) => action.replace('/resumable', '');

export const uploadFile = (file, { action, fields, method = 'PUT' }) => {
  const ajax = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    ajax.open(method, actionToUrl(action), true);
    ajax.addEventListener('load', () => resolve({ action, fields }), false);
    ajax.addEventListener('error', reject, false);
    ajax.addEventListener('abort', reject, false);

    ajax.setRequestHeader('Content-Type', file.type);
    Object.keys(fields).forEach((key) => {
      ajax.setRequestHeader(key, fields[key]);
    });
    ajax.send(file);
  });
};

export const SUPPORTED_TYPES = ['.mp4', '.jpg', '.jpeg', '.png'];
export const SUPPORTED_MIME_TYPES = ['image/jpeg', 'image/png', 'video/mp4'];

export const getImageType = (file) => {
  if (file.type.includes('video')) return 'video';
  return 'normal';
};

export const getBaseFilename = (path) => {
  const idx = path.lastIndexOf('.');
  if (idx === -1) return path || null;
  return path.substr(0, idx).trim() || null;
};

const getType = (file) => {
  if (file.type.includes('image')) return 'photo';
  if (file.type.includes('video')) return 'video';
  return null;
};

export const getDefaultFilename = (file) => {
  return `${format(new Date(file.lastModified), 'y_MM_dd_kkmmss')}_${getType(
    file,
  )}`;
};

export const fileIsVideo = (file) =>
  file.type === 'video/mp4' ||
  (file.name && file.name.toLowerCase().endsWith('.mp4'));

export const FLAGS = {
  REVERSE_REFERENCES: 'svn_reverse_references',
  PHOTO_TAGGING: 'svn_gg_photo_tagging_manual',
  PHOTO_AUTOTAGGING: 'photo-autotags-web',
  PHOTO_LOCATION_COPY: 'svn-photo-location-copy',
  PHOTO_GALLERY_ACCESS: 'svn-photo-gallery-access',
};

export const SETTINGS = {
  HIDE_AUTOTAGS: 'hide-autotags',
};

export const isSettingActivated = (settings, settingName) => {
  const setting = settings.find((s) => s.name === settingName);
  if (setting) {
    return setting.activated;
  }
  return false;
};
